import { render, staticRenderFns } from "./sorting_form.vue?vue&type=template&id=3bc77a56&scoped=true"
import script from "./sorting_form.vue?vue&type=script&lang=js"
export * from "./sorting_form.vue?vue&type=script&lang=js"
import style0 from "./sorting_form.vue?vue&type=style&index=0&id=3bc77a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc77a56",
  null
  
)

export default component.exports